import get from 'lodash/get';
export default function isDebugEnabled() {
    const query = get(global.window, 'location.search', '');
    const debugRegex = /debugMint=true/;
    return !!query.match(debugRegex);
}
